<template>
  <div class="super">
    <div class="service">
      <div
        class="service_main service_advanced"
        :class="{'en-service-main': isEnglish}"
      >
        <h3
          class="service_title"
        >
          {{ $t('message["351"]') }}
          <span v-if="isJoinVip">{{ $t('message["1314"]') }}</span>
        </h3>
        <ul class="service_list">
          <li><li-icon /><span>{{ $t('message["1322"]') }}）</span></li>
          <li><li-icon /><span>{{ $t('message["630"]') }}</span></li>
          <li><li-icon /><span>{{ $t('message["1134"]') }}）</span></li>
          <li><li-icon /><span>{{ $t('message["1258"]') }}</span></li>
          <li><li-icon /><span>{{ $t('message["1663"]') }}logo</span></li>
          <li><li-icon /><span>{{ $t('message["558"]') }}</span></li>
          <li><li-icon /><span>{{ $t('message["711"]') }}</span></li>
        </ul>
        <span class="s-i-btn s-i-cur-btn">{{ $t('message["157"]') }}</span>
      </div>
      <div class="service_b_item">
        <span class="b_item_title">{{ isJoinVip ? expressTit[0]: expressTit[1] }}：</span>
        <div class="b_item_main">
          <template>
            <p
              v-if="isJoinVip"
              class="service_person_num"
            >
              {{ serviceInfo.user_num }}{{ $t('message["929"]') }}
            </p>
            <template v-else>
              <p
                v-show="serviceInfo.user_limit"
                class="service_person_num"
              >
                <!-- {{ isMaturity ? serviceInfo.user_num : serviceInfo.user_limit }} -->
                {{ serviceInfo.user_limit }}{{ $t('message["929"]') }} <span class="has-use-num-tip">({{ $t('message["1781"]') }}{{ serviceInfo.user_num }})</span>
              </p>
            </template>
          </template>
          <template v-if="!isJoinVip">
            <span
              v-if="!$isDingDing"
              class="expation_btn"
              @click="toExpansion"
              v-text="expationTit"
            />
            <ding-tip
              v-else
              type="expand"
            />
          </template>
        </div>
      </div>
      <template>
        <div
          v-if="isJoinVip"
          class="service_b_item"
        >
          <span class="b_item_title">{{ $t('message["1186"]') }}：</span>
          <p
            v-show="serviceInfo.fromtime"
            class="b_item_limit"
          >
            {{ timestampToFormat(serviceInfo.fromtime) }}～{{ timestampToFormat(serviceInfo.totimenew, 2) }}
          </p>
        </div>
        <template v-else>
          <div
            class="service_b_item"
          >
            <span class="b_item_title"> {{ $t('message["310"]') }}：</span>
            <p
              v-show="serviceInfo.fromtime"
              :class="['b_item_limit', isMaturity ? 'maturity' : '']"
            >
              {{ timestampToFormat(serviceInfo.fromtime) }}～{{ timestampToFormat(serviceInfo.totimenew, 2) }}
              <span v-if="isMaturity">{{ $t('message["309"]') }}</span>
            </p>
          </div>
          <div
            v-if="serviceInfo.remark && serviceInfo.remark.t_totime"
            class="service_b_item"
          >
            <span class="b_item_title">{{ $t('message["1186"]') }}：</span>
            <p
              class="b_item_limit maturity"
            >
              {{ timestampToFormat(serviceInfo.remark.t_fromtime) }}～{{ timestampToFormat(serviceInfo.remark.t_totime, 2) }}
            </p>
          </div>
        </template>
      </template>
      <div
        v-if="isMaturity || isJoinVip"
        class="service_b_item"
      >
        <a-button
          v-if="!$isDingDing"
          class="renewal"
          type="primary"
          @click="toRenewal"
          v-text="btnTxt"
        />
        <ding-tip
          v-else
          type="xf"
          :txt="btnTxt"
        />
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import liIcon from './components/SvgLi'
import { mapActions, mapState } from 'vuex'
import { timestampToFormat } from './common'
import { getLang } from '@/lib/storage'
import DingTip from '@/components/pc/serviceup/DingTip'
import i18n from '@/lib/language'

// const EXPATION_TITLE = this.$t('message["579"]')
// const RENEWAL_TITLE = this.$t('message["1409"]')
const CRUMB_TITLE = i18n.t('message["312"]')

export default {
  components: {
    liIcon,
    DingTip
  },
  data () {
    return {
      // RENEWAL_TITLE
    }
  },
  computed: {
    ...mapState('config/service', ['serviceInfo', 'setSubmitting']),
    // 是否展示续费
    isMaturity () {
      return this.serviceInfo.isdisplay
    },
    isJoinVip () {
      const { remark = {} } = this.serviceInfo
      return remark.usedvip === 1
    },
    btnTxt () {
      return this.isJoinVip ? this.$t('message["1050"]') : this.renewalTit
    },
    crumbTit () {
      return this.isJoinVip ? this.$t('message["312"]') : this.expationTit
    },
    expressTit () {
      return this.$t('message["1187"]').split('|')
    },
    expationTit () {
      return this.$t('message["579"]')
    },
    renewalTit () {
      return this.$t('message["1409"]')
    },
    isEnglish () {
      return this.getLang() === 'en'
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.setCrumbLabel(CRUMB_TITLE)
    })
  },
  mounted () {
    // if (!this.setSubmitting) {
    //   this.setCrumbLabel(this.crumbTit)
    // }
    this.setCrumbLabel(CRUMB_TITLE)
  },
  methods: {
    ...mapActions('config/service', ['setCrumbLabel']),
    timestampToFormat,
    getLang,
    toExpansion () {
      this.$router.push({ name: 'ServiceExpasion', query: { type: 4 } })
    },
    toRenewal () {
      this.setCrumbLabel(this.isJoinVip ? this.$t('message["312"]') : this.renewalTit)
      this.$router.push({ name: 'ServiceBuy', query: { type: this.isJoinVip ? 3 : 5 } })
    }
  }
}
</script>

<style scoped lang="scss">
.service_main:first-of-type {
  margin-left: 0;
}
.service_main {
  position: relative;
  display: inline-block;
  width: 320px;
  height: 400px;
  background-image: linear-gradient(274deg, #f2f2f2, #fbfbfb);
  border-radius: 4px;
  overflow: hidden;
  margin-top: 16px;
  .service_title {
    font-size: 24px;
    line-height: 32px;
    color:#333;
    font-family:PingFangSC-Semibold;
    font-weight:600;
    text-align: center;
    margin-top: 40px;
    span{
      font-size: 14px;
      font-weight: normal;
    }
  }
  .service_price {
    text-align: center;
    color: #333;
    margin-top: 22px;
    .price {
      font-family:Roboto-Bold;
      font-size: 64px;
      font-weight: bold;
      b {
        font-size: 24px;
        margin-left: 8px
      }
    }
    .price_unit {
      font-size: 14px;
      font-weight: bold;
    }
    .service_unit_price {
      font-size:14px;
      font-family:PingFangSC-Semibold;
      color:#fff;
      margin-top: 16px;
      opacity: .6;
    }
  }
  .service_list {
    position: absolute;
    width: 100%;
    top: 112px;
    left: 40px;
    li:not(:first-child) {
      margin-top: 12px;
    }
    li {
      svg {
        vertical-align: middle;
      }
      span {
        color: #666;
        margin-left: 8px;
        vertical-align: middle
      }
    }
  }
  .s-i-btn {
    display: inline-block;
    width: 200px;
    height: 40px;
    position: absolute;
    left: 50%;
    bottom: 40px;
    transform: translateX(-50%);
    background: rgba(255,255,255,.2);
    color: rgba(255,255,255,.5);;
    line-height: 40px;
    font-size: 16px;
    border-radius: 4px;
    text-align: center;
    margin-top: 35px;
  }
}
.service_advanced {
  background:linear-gradient(180deg,rgba(101,143,197,1) 0%,rgba(38,70,102,1) 100%);
  margin-left: 40px;
  .service_title, .service_price, .price, .price b, .service_list span {
    color: #fff !important
  }
  .s-i-advanced-btn {
    background: #fff;
    color: #5077AA
  }
}
.service {
  min-width: 320px;
  .service_b_item:first-of-type {
    margin-top: 40px
  }
  .service_b_item:last-of-type {
    margin-bottom: 40px;
  }
  .service_b_item {
    min-width: 320px;
    height: 32px;
    margin-top: 24px;
    position: relative;
    .b_item_title {
      display: inline;
      color: #666
    }
    .b_item_limit {
      display: inline;
      color: #333;
      line-height: 32px;
    }
    .maturity {
      color: #F57676
    }
    .renewal {
      margin-left: 73px;
    }
    .b_item_main {
      display: inline-flex;
      height: 100%;
      line-height: 32px;
      justify-content: space-between;
      margin-left: 12px;
      .service_person_num {
        color: #333
      }
      .expation_btn {
        display: inline-block;
        // position: absolute;
        // left: 267px;
        box-sizing: border-box;
        padding: 4px 12px;
        line-height: 24px;
        background: #F5F5F5;
        color: #333;
        text-align: center;
        box-shadow:0px 2px 0px 0px rgba(255,255,255,0.5);
        border-radius:4px;
        border:1px solid rgba(235,235,235,1);
        transition: all .3s;
        margin-left: 10px;
      }
      .expation_btn:hover {
        cursor: pointer;
        color: #5077AA;
        background: #FFFFFF;
      }
      // .expation_btn_english {
      //   left: 287px;
      // }
    }
  }
}
.en-service-main {
  height: auto !important;
  .service_list {
    width: 265px;
    position: static;
    margin: 35px auto 0;
    li {
      position: relative;
      padding-left: 24px;
      line-height: 22px;
      svg{
        position: absolute;
        left: 0;
        width: 16px;
        height: 16px;
        top: 4px;
      }
      span {
        margin-left: 0;
      }
    }
  }
  .s-i-btn {
    transform: translateX(0);
    margin: 30px auto 35px;
    position: static;
    display: block;
  }
}
.has-use-num-tip {
  color: #b3b3b3;
}
</style>
